export default __webpack_public_path__ + "static/media/pa.3f4707c9.svg";